import { ChannelDTO, ChannelDtoMultiselectVM } from "app/shared/models/channel.model";
import { PaymentTermDto, PaymentTermVM } from "./customer-check-in.model";

export class PaymentTermsByChannelVM {
  channel: ChannelDtoMultiselectVM;
  paymentTerm: PaymentTermVM;
  paymentTermId: number;
  channelId?: number;
  id?: number;
  constructor(init?: PaymentTermsByChannelVM) {
    Object.assign(this, init);
    if (!this.channel) this.channel = new ChannelDtoMultiselectVM();
    if (!this.paymentTerm) this.paymentTerm = new PaymentTermVM();
  }
}
export class PaymentTermsByChannelDTO {
  channel?: ChannelDTO;
  paymentTerm?: PaymentTermDto;
  paymentTermId?: number;
  channelId?: number;
  id?: number;
  constructor(init?: PaymentTermsByChannelDTO) {
    Object.assign(this, init);
  }
}
